import { studentCourseGroupsActionTypes, studentGroupConceptsActionTypes } from './ActionTypes';
import displayGlobalMessage from 'Utils/DisplayGlobalMessage';

//interfaces
import { ICourseGroup, IGroupConcept } from 'store/StateInterfaces';

export function loadCourseGroupsRequest(courseid: number) {
    return dispatch => {
        const url = `/courseware/api/course/${courseid}/groups/?format=json`;
        return fetch(url)
            .then(response => response.json())
            .then(response => {
                let groups = response === "" ? [] : response;
                dispatch(loadCourseGroupsSuccess(courseid, groups));
            })
            .catch(error => {
                displayGlobalMessage("Group Loading Failed", 'error');
                throw (error);
            })

    }
}


export function loadCourseGroupsSuccess(courseid: number, groups: Array<ICourseGroup>) {
    return {
        type: studentCourseGroupsActionTypes.LOAD_STUDENT_COURSE_GROUPS_SUCCESS,
        courseid,
        groups
    }
}

export function loadGroupConceptsRequest(groupid) {
    return dispatch => {
        const url = `/courseware/api/group/${groupid}/concepts/`;
        console.log(url);
        return fetch(url)
            .then(res => res.json())
            .then(res => {
                let concepts = res === "" ? [] : res;
                dispatch(loadGroupConceptsSuccess(groupid, concepts));
            })
            .catch(err => {
                displayGlobalMessage("Load Concept Failed", "error");
                throw (err);
            });

    }
}



export function loadGroupConceptsSuccess(groupid: number, concepts: Array<IGroupConcept>) {
    return {
        type: studentGroupConceptsActionTypes.LOAD_STUDENT_GROUP_CONCEPTS_SUCCESS,
        groupid,
        concepts
    }
}